import React from 'react';

// import img
import Image from '../assets/img/241289407_267620468512220_4064969604892437530_n.jpg';

const About = () => {
  return (
    <section className='section bg-secondary' id='about'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row gap-24'>
          <img
            className='object-cover h-full w-[566px] md:mx-auto lg:mx-0 rounded-2xl'
            src={Image}
            alt=''
          />
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left'>
            <div className='flex flex-col'>
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                Avisheik Barua
              </h2>
              <p className='mb-4 text-accent'>
                Web Developer
              </p>
              <hr className='mb-8 opacity-5' />
              <p className='mb-8'>
                I am grateful to you for visiting my profile. Recently I completed my BSc degree in Computer Science and Engineering. I have already finished my learning path to becoming a full-stack developer. Now, I can describe why you should hire me as a full-stack developer.
                What I'm bringing with me
                <br />
                ➤ I regularly use JavaScript, ReactJs, Bootstrap, tailwindCss, NodeJs, Vscode, and Git.
                <br />
                ➤ Currently, I am Learning MongoDb, ExpressJs
                <br />
                ➤ I have completed a few Projects in which Hosting links are visible in my profile <br />
                <br />
                Important Links:
                Github Links: https://github.com/Avisheik1721158
              </p>
            </div>
            <button className='btn btn-md bg-accent hover:bg-secondary-hover transition-all'>
              Contact me
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
